import { PL_GROUPS, sumMappedLines } from "./line-mapping.js";
import { sumCents, type Cents } from "./money.js";
import type { CalcLineItem } from "./types.js";

const REVENUE = new Set<string>(PL_GROUPS.revenue);

export function selectedRevenueLines(lines: readonly CalcLineItem[]): CalcLineItem[] {
  // Income / Sales is the older sales type; use it only when the period's gross
  // revenue sums to zero. A negative gross total is still present.
  const hasGrossRevenue = sumMappedLines(lines, ["gross_revenue_sales"]) !== 0;
  return lines.filter(line => REVENUE.has(line.lineItem) && !(hasGrossRevenue && line.lineItem === "income_sales"));
}

/** Net revenue for one period, using the cascade's signed contra-revenue rule. */
export function netRevenueCents(lines: readonly CalcLineItem[]): Cents {
  return deductContraRevenueCents(
    sumCents(selectedRevenueLines(lines).map(line => line.amountCents)),
    sumMappedLines(lines, PL_GROUPS.contraRevenue),
  );
}

/** Apply the signed deduction after revenue selection and any scaling. */
export function deductContraRevenueCents(revenueCents: Cents, contraRevenueCents: Cents): Cents {
  return sumCents([revenueCents, -contraRevenueCents]);
}
